/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


	$(".menu-icon-svg").on("click", function () {
		$(this).toggleClass("active");
		$('body').toggleClass("menu-scroll-fix");
		$('.top-bar').toggleClass("z-control");
		$('.mobile-nav-wrap').toggleClass("active");
		$(".close-icon").toggleClass("active");
		$('header.header').toggleClass("active");
		console.log('click');
	  });


	 
	


	//Smooth scroll
	// filter handling for a /dir/ OR /indexordefault.page
function filterPath(string) {
	return string
	  .replace(/^\//, '')
	  .replace(/(index|default).[a-zA-Z]{3,4}$/, '')
	  .replace(/\/$/, '');
  }
  
  var locationPath = filterPath(location.pathname);
  $('a[href*="#"]').not( '.non-scroll' ).each(function () {
	var thisPath = filterPath(this.pathname) || locationPath;
	var hash = this.hash;
	if ($("#" + hash.replace(/#/, '')).length) {
	  if (locationPath == thisPath && (location.hostname == this.hostname || !this.hostname) && this.hash.replace(/#/, '')) {
		var $target = $(hash), target = this.hash;
		if (target) {
		  $(this).click(function (event) {
			event.preventDefault();
			$('html, body').animate({scrollTop: $target.offset().top}, 1000, function () {
			  location.hash = target; 
			  $target.focus();
			  if ($target.is(":focus")){ //checking if the target was focused
				return false;
			  }else{
				$target.attr('tabindex','-1'); //Adding tabindex for elements not focusable
				$target.focus(); //Setting focus
			  };
			});       
		  });
		}
	  }
	}
  });


  // Add classes for customized blocks 
  $('.is-style-image-right-decoration-purple-first').each(function(){
    $(this).addClass('animation-element purple-decoration');
});

$('.is-style-image-left-decoration-purple-first').each(function(){
    $(this).addClass('animation-element purple-decoration');
});

$('.is-style-image-right-decoration-purple').each(function(){
    $(this).addClass('animation-element purple-decoration');
});

$('.is-style-image-left-decoration-pink').each(function(){
    $(this).addClass('animation-element pink-decoration');
});


$.fn.isInViewport = function() {

	var elementTop = $(this).offset().top;

	var elementBottom = elementTop + $(this).outerHeight() / 2;

	var viewportTop = $(window).scrollTop();

	var viewportHalf = viewportTop + $(window).height() / 2;

	return elementBottom > viewportTop && elementTop < viewportHalf;

};

$(window).on('load resize scroll', function() {

	$('.animation-element').each(function() {

		if ($(this).isInViewport()) {
			$(this).addClass('in-view');

		} else {
			//$(this).addClass('in-view');

		}

	});

});


$(window).on('load resize', function() {
	// Manage overflow text on Value of Protego-PD circles
$('.wf-circle').each(function() {
    var maxHeight = 130;
    $(this).removeClass('wf-height');
	$(this).removeClass('active');
        if($(this).height() > maxHeight) {
			$(this).toggleClass('wf-height');  
			
        }
		
}); // END Manage overflow text on Value of Protego-PD circles

// Move titles out of media-text block for mobile
if ($(window).width() < 820) {
	$(".is-style-image-left-decoration-purple-first h2:not([class*='align-center'])").addClass("text-center moved");
$(".is-style-image-left-decoration-purple-first h2").insertBefore(".is-style-image-left-decoration-purple-first");
} else {
	$("h2.moved").prependTo(".is-style-image-left-decoration-purple-first .wp-block-media-text__content");
	$("h2.moved").removeClass("text-center moved");
}
if ($(window).width() < 820) {
	$(".is-style-image-right-decoration-purple-first h2:not([class*='align-center'])").addClass("text-center moved");
	$(".is-style-image-right-decoration-purple-first h2").insertBefore(".is-style-image-right-decoration-purple-first");
	} else {
		$("h2.moved").prependTo(".is-style-image-right-decoration-purple-first .wp-block-media-text__content");
		$("h2.moved").removeClass("text-center moved");
	}

}); // END Move titles out of media-text block for mobile

// Toggle acttive class on Value of Protego-PD circles
$('.wf-circle').on("click", function () {
	console.log ('click');
	$(this).toggleClass("active");
});




// Show hide references

  $(".showhide-button").click(function(){
    $(this).text($(this).text() == '(show)' ? '(hide)' : '(show)'); 
    $(".showtext").slideToggle("slow");

  });


});